import terms from "../../../docs/legal/termos-de-uso.md?raw";
import privacy from "../../../docs/legal/politica-de-privacidade.md?raw";

export type LegalDocumentHashes = { terms: string; privacy: string };

async function sha256(text: string): Promise<string> {
  const bytes = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(bytes), (byte) => byte.toString(16).padStart(2, "0")).join("");
}

// Hash precisely what LegalDocument renders, not a manually copied version.
export async function getLegalDocumentHashes(): Promise<LegalDocumentHashes> {
  const [termsHash, privacyHash] = await Promise.all([sha256(terms), sha256(privacy)]);
  return { terms: termsHash, privacy: privacyHash };
}
